import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text-information-field",
  "use": "icon-text-information-field-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-text-information-field\"><path d=\"M106.666667 106.666667h810.666666v810.666666H106.666667V106.666667z m85.333333 85.333333v640h640V192H192z m277.333333 277.333333h85.333334v277.333334h-85.333334V469.333333z m42.666667-64a64 64 0 1 1 0-128 64 64 0 0 1 0 128z\" p-id=\"5162\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol